var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_95_254)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_254)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 262,
    height: 262,
    rx: 27,
    fill: "url(#paint0_linear_95_254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 251.282C256 242.055 253.179 232.942 247.013 226.077C234.481 212.125 219.458 200.603 202.683 192.134C181.682 181.532 158.513 176.007 135.019 176C111.525 175.993 88.3536 181.502 67.3454 192.092C50.5698 200.548 35.543 212.056 23.0043 225.995C16.8273 232.862 14.0007 241.986 14.0005 251.222C14.0004 262.725 14.0002 275.117 14 286.38C13.9999 302.574 23.3992 316.956 39.3103 319.968C70.7739 325.923 117.494 328.994 134.981 329C152.466 329.006 199.194 325.922 230.669 319.966C246.59 316.954 256 302.561 256 286.357C256 275.199 256 262.614 256 251.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 157C167.033 157 193 130.809 193 98.5C193 66.1913 167.033 40 135 40C102.967 40 77 66.1913 77 98.5C77 130.809 102.967 157 135 157Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_95_254",
    x: 0,
    y: 0,
    width: 270,
    height: 270,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_95_254"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_95_254",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_254",
    x1: 4,
    y1: 266,
    x2: 266,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FABB76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 262,
    height: 262,
    rx: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageUser);
export default __webpack_public_path__ + "static/media/image-user.1b02e4e52f5d663d6fbb34aaa17c298b.svg";
export { ForwardRef as ReactComponent };